<template>
    <v-dialog
        v-if="showDialog"
        :model-value="exportDStabilityDialog"
        max-width="400"
        @click:outside="cleanUpAndCloseDialog"
    >
        <v-card>
            <v-card-title class="pt-4">Export D-Stability</v-card-title>
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    :loading="exportDStabilityLoading"
                    color="primary"
                    text
                    :disabled="exportDStabilityLoading"
                    @click="onExportDStability"
                >
                    Export
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "SchematisationExportDStabilityDialog",
    computed: {
        ...mapState('stabSchematisation', {
            exportDStabilityDialog: state => state.exportDStabilityDialog,
            schematisationToExport: state => state.currentOverviewItem,
            exportDStabilityLoading: state => state.exportDStabilityLoading,
        }),
        showDialog() {
            return this.schematisationToExport?.id > 0;
        },
    },
    methods: {
        ...mapActions('stabSchematisation', {
            toggleExportDStabilityDialog: "toggleExportDStabilityDialog",
            exportDStability: "exportDStability",
        }),
        async onExportDStability() {
            try {
                await this.exportDStability(this.schematisationToExport.id);
            } catch (e) {
                console.log(e);
            } finally {
                await this.cleanUpAndCloseDialog();
            }
        },
        async cleanUpAndCloseDialog() {
            await this.toggleExportDStabilityDialog();
        },
    },
}
</script>
